import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useCreateLegalClientLegalHeadMutation } from 'api/generated/graphql';
import { parseLegalClientLegalHeadEntity, useError } from 'api/helpers';
import { parseOrganizationalAndLegalFormParam } from 'api/helpers/legal/parseParam';
import { CreateLegalClientLegalHeadParams } from 'api/types/params';

export const useCreateLegalClientLegalHead = () => {
  const [handle, { data, loading, error: apolloError }] =
    useCreateLegalClientLegalHeadMutation();

  const error = useError(apolloError);

  return {
    legalClientHead: data?.createLegalClientLegalHead
      ? parseLegalClientLegalHeadEntity(data.createLegalClientLegalHead)
      : undefined,
    loading,
    error,
    createLegalClientLegalHead: useCallback(
      async (params: CreateLegalClientLegalHeadParams) => {
        const res = await handle({
          variables: {
            input: {
              ...params,
              organizationalAndLegalForm: params.organizationalAndLegalForm
                ? parseOrganizationalAndLegalFormParam(
                    params.organizationalAndLegalForm
                  )
                : undefined,
            },
          },
        });
        return res.data?.createLegalClientLegalHead
          ? parseLegalClientLegalHeadEntity(
              res.data?.createLegalClientLegalHead
            )
          : undefined;
      },
      [handle]
    ),
  };
};
